module.exports = __webpack_public_path__ + "letterFadeInStart.gif";